import type { InteriorView } from "@slfinrtl/ui-bff-routes"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { withErrorHandler } from "src/context/errorHandler/withErrorHandler"
import type { OrderType } from "../../OrderType"
import { useSelectCatalogInterior } from "./useSelectCatalogInterior"
import { SelectCatalogInteriorColor } from "./view/SelectCatalogInteriorColor"
import { SelectCatalogInteriorSkeleton } from "./view/SelectCatalogInteriorSkeleton"

export interface SelectCatalogInteriorContainerProps {
	currentInterior: InteriorView | undefined
	inventoryId: string
	onInteriorSelected: (interior: InteriorView) => void
	orderType: OrderType
	showCustomInteriorContainer: () => void
}

export const SelectCatalogInteriorContainer = withErrorHandler((props: SelectCatalogInteriorContainerProps) => {
	const { viewProps } = useSelectCatalogInterior(props)

	return (
		<>
			<ErrorNotificationInline />
			{viewProps ? <SelectCatalogInteriorColor {...viewProps} /> : <SelectCatalogInteriorSkeleton />}
		</>
	)
})
